<template>
  <div class="component-custom">
    <p>custom component</p>
    <h1 v-html="content.title"></h1>
    <p v-html="content.description"></p>
  </div>
</template>

<script>
export default {
  props: ['attributes'],
  computed: {
    content () {
      return this.attributes.value
    }
  }
}
</script>
